import { render } from "./ToggleStatus.vue?vue&type=template&id=f04ac9e0"
import script from "./ToggleStatus.vue?vue&type=script&lang=js"
export * from "./ToggleStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__